module.exports = __webpack_public_path__ + "img/check-solid.e597acab.svg";